import React, { Component } from 'react';
import { Button, Col, Collapse, Row } from 'reactstrap';
import CaretToggle from '../Icons/CaretToggle';
import HtmlHelpers from '../HtmlHelpers';
import ListFunctions from '../FunctionsList';
import WmReactTable from '../Layout/WmReactTable';
import AddForm from './AddForm';
import Columns from './Columns';
export default class Notes extends Component {
  constructor(props) {
    super(props);
    this.addButtonType = () => '';
    this.title = () => '';
    this.modelType = () => '';
    this.modelUuid = () => '';
    this.category = () => '';
    this.categoryParam = () => HtmlHelpers.isEmpty(this.category()) ? '' : "and category = '".concat(this.category(), "'");
    this.storageName = () => '';
    this.hideBottomHr = () => true;
    this.addAdmin = () => false;
    this.queryParams = () => "model_type = '".concat(this.modelType(), "' and model_uuid = '").concat(this.modelUuid(), "' ").concat(this.categoryParam());
    this.modifyData = data => data;
    this.getColumns = () => this.columnsBefore().concat(Columns.getBaseColumns()).concat(this.columnsAfter());
    this.columnsBefore = () => [];
    this.columnsAfter = () => [];
    this.updateState = data => this.setState(data);
    this.updateData = () => {
      this.closeAddNote();
      this.getData();
    };
    this.closeOnZero = () => this.setState(prevState => prevState.data.size === 0 ? {
      notesShowing: false
    } : {
      notesShowing: true
    });
    this.getData = async () => {
      const apiOptions = {
        auth: this.props.auth,
        listApi: "notes?query=".concat(this.queryParams())
      };
      const data = await ListFunctions.fetchData(apiOptions);
      this.setState({
        data: this.modifyData(data.data),
        notePages: data.pages,
        loading: false
      });
    };
    this.addForm = () => !this.state.noteAddModal ? '' : /*#__PURE__*/React.createElement(AddForm, {
      auth: this.props.auth,
      modelType: this.modelType(),
      modelUuid: this.modelUuid(),
      title: "".concat(this.addButtonType(), " Note"),
      showModal: this.state.noteAddModal,
      closeModal: this.closeAddNote,
      updateData: this.updateData
    });
    this.openAddNote = () => this.setState({
      noteAddModal: true
    });
    this.closeAddNote = () => this.setState({
      noteAddModal: false
    });
    this.addButton = () => this.addAdmin() ? /*#__PURE__*/React.createElement(Button, {
      outline: true,
      className: "btn-sm",
      color: "info",
      onClick: this.openAddNote
    }, "Add ".concat(this.addButtonType(), " Note")) : '';
    this.showToggle = () => this.setState(prevState => ({
      notesShowing: !prevState.notesShowing
    }));
    this.notesTable = () => /*#__PURE__*/React.createElement(Collapse, {
      isOpen: true
    }, /*#__PURE__*/React.createElement(WmReactTable, {
      data: this.state.data,
      loading: this.state.loading,
      columns: this.getColumns(),
      className: "otto__short_table"
    }));
    this.getTable = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12"
    }, /*#__PURE__*/React.createElement("h4", null, "".concat(this.title(), " (").concat(this.state.loading ? 'loading' : this.state.data.length, ")"), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
      open: this.state.notesShowing,
      onClick: this.showToggle
    }))), /*#__PURE__*/React.createElement(Col, {
      md: "6",
      xs: "12",
      className: "text-right"
    }, this.addButton())), this.hideBottomHr() ? '' : /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.notesShowing
    }, this.notesTable()));
    this.titleClass = () => '';
    this.getLink = () => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      className: this.titleClass
    }, "".concat(this.title(), " (").concat(this.state.loading ? 'loading' : this.state.data.length, ")")), "\xA0\xA0\xA0", /*#__PURE__*/React.createElement(CaretToggle, {
      className: "otto__no_padding",
      open: this.state.notesShowing,
      onClick: this.showToggle
    }), /*#__PURE__*/React.createElement(Collapse, {
      isOpen: this.state.notesShowing
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
      md: "12",
      xs: "12",
      className: "text-right"
    }, this.addButton())), this.notesTable()));
    this.renderType = () => this.getTable();
    this.render = () => /*#__PURE__*/React.createElement("div", null, this.renderType(), this.addForm());
    this.state = {
      noteOpen: true,
      loading: true,
      noteAddModal: false,
      notesShowing: false,
      data: []
    };
  }
}